shadow$provide[4] = function(require,module,exports) {

};